<template>
  <PageWrapper has-filters @submitFilters="getAllUserBoughtPackagesList" :isLoading="isLoading">
    <template #title>
      لیست پکیج های خریداری شده {{ userFullName ? userFullName : "" }}
    </template>
    <template
      #titleBtn
      v-if="canAddLesson && $can('AddLessonToUserArray', 'Order')"
    >
      <BButton variant="success" @click="renderAddPackageToUserModal">
        افزودن پکیج
      </BButton>
    </template>
    <template #filters>
      <LessonCategoryPicker
          class="w-24 filters-width"
          is-multiple
          @getLessonCategory="setLessonCategories"
        ></LessonCategoryPicker>
      <SearchInput
        inputLabel="توضیحات تراکنش"
        inputPlaceholder="بابت خرید پکیج"
        :inputValue="packagesFilter.description"
        v-model="packagesFilter.description"
        @enter="setPageNumberAndGetAllOrders"
      ></SearchInput>
      <CustomDatePicker
        class="w-24 filters-width"
        inputId="boughtDate"
        @getSelectedDate="setCreateDateFilter"
        inputLabel="تاریخ خرید"
        inputPlaceholder="تاریخ خرید"
      ></CustomDatePicker>
    </template>
    <CustomTable
      v-if="packagesList"
      :pageNumber="packagesFilter.pageNumber"
      :count="packagesFilter.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="packagesList"
      @changePage="changePage"
    >
      <template #lessonTitle="data">
        <b-link :to="`/independent-lessons/${data.item.lessonId}`">
          {{ data.item.lessonTitle }}
        </b-link>
      </template>
      <template #createDate="data">
        {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
        -
        {{
          new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        }}
      </template>
      <template #actions="data">
        <BButton
          variant="transparent"
          size="sm"
          @click="renderDeleteConfirmationModal(data.item)"
        >
          <feather-icon size="20" icon="Trash2Icon" class="text-danger" />
        </BButton>
      </template>
    </CustomTable>
    <AddPackageToUserModal
      :externalUserId="userIdFilter"
      @updateLessons="updatePackagesList"
    ></AddPackageToUserModal>
    <LessonDeleteModalConfirmation
      :lessonTitle="computedTempLessonTitle"
      @removeLesson="sendLessonRemoveRequest"
    ></LessonDeleteModalConfirmation>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.setTableColumnsIfCanAddLessonChanged();
    this.packagesFilter.userId = this.userIdFilter;
    this.getAllUserBoughtPackagesList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllUserBoughtPackagesList();
      },
    },
    canAddLesson: {
      handler(val) {
        this.setTableColumnsIfCanAddLessonChanged();
      },
    },
  },
  emits: ["updateOrdersList"],
  props: {
    userIdFilter: {
      type: [String, Number],
      required: true,
    },
    userFullName: {
      type: [String],
      required: false,
    },
    canAddLesson: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      packagesFilter: {
        pageNumber: 1,
        count: 10,
        id: null,
        userId: null,
        fullName: null,
        mobile: null,
        email: null,
        createDate: null,
        description: null,
        lessonId: null,
        lessonTitle: null,
        priceCategoryId:null,
      },
      isLoading: false,
      totalCount: null,
      packagesList: null,
      tempLesson: null,
      myTableColumns: [
        {
          key: "title",
          label: "عنوان پکیج",
        },
        {
          key: "createTime",
          label: "تاریخ ثبت تراکنش",
        },
        {
          key: "description",
          label: "توضیحات تراکنش",
        },
      ],
    };
  },
  methods: {
    setPriceCategoryId(priceCategoryId) {
      this.packagesFilter.packageId = priceCategoryId;
    },
    renderDeleteConfirmationModal(lesson) {
      this.tempLesson = JSON.parse(JSON.stringify(lesson));
      this.$bvModal.show("remove-lesson-from-user");
    },
    setCreateDateFilter(date) {
      if (date) {
        this.packagesFilter.createDate = new Date(date).toISOString();
      } else {
        this.packagesFilter.createDate = null;
      }
    },
    setTableColumnsIfCanAddLessonChanged() {
      if (this.canAddLesson) {
        this.myTableColumns.splice(3, 0, {
          key: "actions",
          label: "عملیات",
        });
      } else {
        this.myTableColumns.splice(3, 1);
      }
    },
    changePage(pageNumber) {
      this.packagesFilter.pageNumber = pageNumber;
      this.getAllUserBoughtPackagesList();
    },
    updatePackagesList() {
      this.$emit("updateOrdersList");
      this.getAllUserBoughtPackagesList();
    },
    renderAddPackageToUserModal() {
      if (this.renderAddPackageToUserModal) {
        this.$bvModal.show("add-package-to-user");
      }
    },
    clearDateFilter() {
      this.packagesFilter.createDate = null;
    },
    setLessonCategories(data){
      this.packagesFilter.packageId=data
    },
    setPageNumberAndGetAllOrders() {
      this.packagesFilter.pageNumber = 1;
      this.getAllUserBoughtPackagesList();
    },
    createJalaliDate(date) {
      if (date) {
        const myCustomDate = new Date(date).toLocaleDateString("fa-IR");
        return `${myCustomDate}`;
      } else {
        return null;
      }
    },
    async sendLessonRemoveRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let removeLessonFromUser = new RemoveLessonFromUser(_this);
        removeLessonFromUser.setRequestParam({
          userId: _this.userIdFilter,
          lessonId: _this.tempLesson.lessonId,
        });
        await removeLessonFromUser.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "درس با موفقیت حذف شد!",
              },
            });
            _this.$bvModal.hide("remove-lesson-from-user");
            _this.tempLesson = null;
            _this.getAllUserBoughtPackagesList();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.message || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllUserBoughtPackagesList() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllUserBoughtPackages = new GetAllUserBoughtPackages(_this);
        getAllUserBoughtPackages.setRequestParamDataObj(_this.packagesFilter);
        await getAllUserBoughtPackages.fetch((res) => {
          _this.packagesList = res.data.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.packagesFilter.pageNumber;
    },
    computedTempLessonTitle() {
      if (this.tempLesson && this.tempLesson.lessonTitle) {
        return this.tempLesson.lessonTitle;
      }
      return null;
    },
  },
  components: {
    PageWrapper,
    BButton,
    BLink,
    AddPackageToUserModal,
    SearchInput,
    CustomDatePicker,
    LessonDeleteModalConfirmation,
    CustomTable,
    LessonCategoryPicker,
  },
};
import { GetAllUserBoughtLessons } from "@/libs/Api/UserBoughtLesson";
import {GetAllUserBoughtPackages} from "@/libs/Api/LessonCategory";
import { RemoveLessonFromUser } from "@/libs/Api/Order";
import LessonCategoryPicker from "@/views/components/LessonCategories/LessonCategoryPicker.vue";
import AddPackageToUserModal from "./AddPackageToUserModal.vue"
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LessonDeleteModalConfirmation from "@/views/components/UserBoughtLessons/LessonDeleteModalConfirmation.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BButton, BLink } from "bootstrap-vue";
</script>
